<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="售后申请"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-form @submit="onSubmit">
        <div class="batch-item">
        <!--   球杆序列号     -->
        <van-field
            readonly
            clickable
            name="number"
            :value="formData.number"
            label="球杆编码"
            placeholder="点击选择球杆编码"
            @click="showPicker = true"
            class="search-input"
            :rules="[{ required: true}]"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
              show-toolbar
              :columns="selectOptions"
              @confirm="onConfirm"
              @cancel="showPicker = false"
          />
        </van-popup>
        <!--   原因说明     -->
        <van-field name="checkType" label="原因说明"  :rules="[{ required: true, message: '请选择原因说明' }]">
          <template #input>
            <van-radio-group v-model="formData.checkType" direction="horizontal">
              <van-radio name="保养维护">保养维护</van-radio>
              <van-radio name="木头开裂">木头开裂</van-radio>
              <van-radio name="铜头松动">铜头松动</van-radio>
              <van-radio name="球杆调直">球杆调直</van-radio>
              <van-radio name="其它原因">其它原因</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <!--   原因说明描述     -->
        <van-field
            v-model="formData.description"
            name="description"
            rows="2"
            autosize
            label=""
            type="textarea"
            placeholder="请输入问题描述（选填）"
        />
        <van-field name="fileList" label="问题图片"  :rules="[{ required: true, message: '请上传问题图片' }]">
          <template #input>
            <van-uploader v-model="fileList" multiple :max-count="3" />
          </template>
        </van-field>
        <van-field v-model="formData.userName" name="userName" label="姓名" placeholder="请输入您的姓名" :rules="[{ required: true }]" />

        <van-field v-model="formData.telephone" name="telephone" label="电话" placeholder="请输入您的电话" :rules="[{ validator:telValidator }]"/>

        <van-field
            readonly
            clickable
            name="area"
            :value="provinceValue"
            label="地址"
            placeholder="点击选择省市区"
            @click="showArea = true"
            :rules="[{ required: true }]"
        />
        <van-popup v-if="showArea" v-model="formData.province" position="bottom">
          <van-area
              :area-list="areaList"
              @confirm="onCityConfirm"
              @cancel="showArea = false"
          />
        </van-popup>

        <van-field v-model="formData.detailAddr"
                   name="detailAddr"
                   rows="1"
                   autosize
                   type="textarea"
                   label="详细地址"
                   placeholder="请输入您的详细地址"
                   :rules="[{ required: true }]"
        />

        <div style="margin: 16px;">
          <van-button class="submit-btn" round block type="info" native-type="submit">提交申请</van-button>
        </div>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {afterPost, productByUser} from "@/api/sales";
import {Dialog} from "vant";
import { areaList } from '@vant/area-data';

export default {
  data(){
    return {
      // 表单数据
      formData: {
        number: "",
        checkType: [],
        description: "",
        userName: "",
        telephone: "",
        province: "",
        city: "",
        detailAddr: "",
      },
      selectOptions: [],
      showPicker: false,

      provinceValue: '',
      showArea: false,
      areaList,
      fileList: [],
    }
  },
  created() {
    this.selectProductByUser();
  },
  methods: {
    telValidator(val) {
      if(val){
        const reg = /^1[3-9]\d{9}$/;
        if (!reg.test(val)) {
          return false;
        }
      }else{
        return false;
      }
    },
    onSubmit(values){
      const formData = new FormData();

      formData.append('number', values.number);
      formData.append('checkType', values.checkType); // 单选值，直接传
      formData.append('description', values.description);
      formData.append('userName', values.userName);
      formData.append('telephone', values.telephone);
      formData.append('address', values.area.replaceAll('/','')+values.detailAddr);

      const files = [];
      this.fileList.forEach(item => {
        if (item.file) {
          files.push(item.file);
          formData.append('rImg', item.file);
        }
      });

      afterPost(formData).then(res => {
        if(res.code==200){
          const data = res.data;
          if (data.code == 1) {
            this.showDialogMsg(data.returnMsg);
            this.formData= {
                number: "",
                checkType: [],
                description: "",
                userName: "",
                telephone: "",
                province: "",
                city: "",
                detailAddr: "",
            }
          }else if(data.code ==0) {
            this.showDialogMsg(data.returnMsg);
          }else if(data.code ==2){
            this.showDialogMsg(data.returnMsg);
          }else if(data.code ==3){
            this.showDialogMsg(data.returnMsg);
          }else if(data.code ==4){
            this.showDialogMsg(data.returnMsg);
          } else if(res.data.code ==0){
            this.showDialogMsg(data.returnMsg);
          }
        }else{
          this.showDialogMsg(res.data.returnMsg);
        }
      });
    },
    //顶部标题栏返回事件
    onClickLeft() {
      this.$router.push('/app_home');
    },
    //序列号确认事件
    onConfirm(value) {
      this.formData.number = value;
      this.showPicker = false;
    },

    onCityConfirm(values){
      this.provinceValue = values
          .filter((item) => !!item)
          .map((item) => item.name)
          .join('/');
      this.showArea = false;
    },

    showDialogMsg(message){
      Dialog.alert({
        title: '查询结果',
        message: message,
        dangerouslyUseHTMLString: true
      });
    },
    //获取当前登录人名下注册登记的球杆
    selectProductByUser(){
      productByUser().then(res => {
        if (res.code === 200) {
          if(res.data){
            this.selectOptions = res.data.map(item => item.value);
          }
        } else {
          Dialog.alert({
            title: '提示',
            message: res.returnMsg,
            dangerouslyUseHTMLString: true
          }).then(() => {
            // on close
          });
        }
      }).catch(err => {
        Dialog.alert({
          title: '错误',
          message: '获取球杆编码失败，请稍后重试',
          dangerouslyUseHTMLString: true
        });
      })
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}
.van-radio--horizontal{
  margin-bottom: 10px;
}
.top-bar{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}
.container-item {
  margin-bottom: 60px;
}
.batch-item {
  padding: 10px;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 15px;
}
.submit-btn{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
}
</style>